/**
 * /app/$tenantSlug/performance/cycles/new — create a review cycle (HR).
 * On the RUN surface, next to Cycle administration (2026-10 QA: it lived
 * under /performance/reviews and flipped the sidebar to Inbox). The old
 * /performance/reviews/new redirects here.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewCycleForm } from "@/components/performance/review-cycle-form";
import { usePerformanceRoles } from "@/components/performance/use-performance-roles";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/cycles/new",
)({
  component: NewCycleRoute,
});

function NewCycleRoute() {
  const { isPerfAdmin } = usePerformanceRoles();
  return (
    <PerformanceModuleShell
      title="New Review Cycle"
      description="Create a cycle as a draft, then configure its questions and reviewer roster."
    >
      <PerformanceFeatureGate>
        <Card className="max-w-2xl">
          <CardContent className="py-6">
            {isPerfAdmin ? (
              <ReviewCycleForm />
            ) : (
              <p className="text-sm text-muted-foreground">
                Only HR can create review cycles.
              </p>
            )}
          </CardContent>
        </Card>
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
